'use client'

import React from "react";
import {cn} from "@/lib/utils";
import Image from "next/image";
import fadingSquares from "@/public/global/fadingSquares.png";
import fadingSquares2 from "@/public/global/fadingSquares2.png";

export default function DecorationSquares({
  style = "default",
  className = "",
}: {
  style?: "default" | "green";
  className?: string;
}){
  return (
    <Image
      className={cn(
        "absolute left-1/2 -translate-x-1/2 pointer-events-none !w-[120rem] max-w-[unset]",
        className
      )}
      src={style === "green" ? fadingSquares2 : fadingSquares}
      alt="background decoration squares"
    />
  );
}